/* Delilah quick add + cart helpers.
   - [data-dl-add="VARIANT_ID"] buttons add 1 to the basket. data-dl-open="false" keeps the basket drawer closed.
   - window.DelilahCart.add / change / get are shared with the product-page bundle box.
   After every change the header count is updated and the cart drawer re-renders (opened only when asked). */
(function () {
  if (window.DelilahCart) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var JSONH = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function done(cart, open) {
    document.querySelectorAll('cart-count').forEach(function (el) { el.innerText = cart.item_count; el.hidden = cart.item_count === 0; });
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: !!open } }));
    document.dispatchEvent(new CustomEvent('dl:cart', { detail: { cart: cart } }));
    return cart;
  }
  function failOn(r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); }

  window.DelilahCart = {
    get: getCart,
    add: function (id, qty, open) {
      return fetch(root + 'cart/add.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] }) })
        .then(failOn).then(getCart).then(function (cart) { return done(cart, open); });
    },
    change: function (key, qty) {
      return fetch(root + 'cart/change.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ id: String(key), quantity: qty }) })
        .then(failOn).then(function (cart) { return done(cart, false); });
    }
  };

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-dl-add]');
    if (!b) return;
    e.preventDefault();
    if (b.getAttribute('aria-busy') === 'true') return;
    b.setAttribute('aria-busy', 'true');
    b.classList.add('is-loading');
    DelilahCart.add(b.getAttribute('data-dl-add'), 1, b.getAttribute('data-dl-open') !== 'false')
      .then(function () {
        b.classList.add('is-added');
        setTimeout(function () { b.classList.remove('is-added'); }, 1600);
      })
      .catch(function (err) { b.title = (err && (err.description || err.message)) || 'Sorry, that could not be added'; b.classList.add('is-error'); })
      .then(function () { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
  });
})();
